import { render } from "./LbrxProductPopup.vue?vue&type=template&id=95574d80&scoped=true"
import script from "./LbrxProductPopup.vue?vue&type=script&lang=js"
export * from "./LbrxProductPopup.vue?vue&type=script&lang=js"

import "./LbrxProductPopup.vue?vue&type=style&index=0&id=95574d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95574d80"]])

export default __exports__